import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeVatId: (value: string) => void;
}

export const VatIdField: React.FC<IProps> = React.memo(({ changeVatId }) => {
	return <FormInput testId="VatIdField" name="vatId" label="vatIdLabel" onChange={changeVatId} />;
});
